import React, { useState } from "react";
import { Theme, FormControl, Checkbox } from "@material-ui/core";

import { makeStyles } from "@material-ui/core/styles";
import Select from "react-select";
import axios from "axios";
import _ from "lodash";
import { Modal } from "rsuite";
import "rsuite/dist/styles/rsuite-default.css";
import { useHistory } from "react-router-dom";
import FormInput from "../components/form-input";
import Button from "../components/custom-button";
import { t } from "../i18n";
import { globalStore } from "../stores/global";
import { remoteConfig } from "../firebase";
import { useAuth } from "../services/auth-check";
import PhoneAndroid from "@material-ui/icons/PhoneAndroid";
import Person from "@material-ui/icons/Person";
import Email from "@material-ui/icons/Email";
import Https from "@material-ui/icons/Https";
import Language from "@material-ui/icons/Language";
import ArrowBack from "@material-ui/icons/ArrowBack";
import ArrowForward from "@material-ui/icons/ArrowForward";

import {
  API_COMMON_URL,
  API_V1_USERS,
  AUTH_API,
} from "../services/ihr-meet-api";

import LangSelect from "../components/lang-select";
import GlobalStorage from "../utils/custom-storage";

const useStyles = makeStyles((theme: Theme) => ({
  formControl: {
    minWidth: "100%",
    maxWidth: "100%",
  },
}));

type SessionInfo = {
  roomName: string;
  roomType: number;
  yourName: string;
  role: string;
  name: string;
  email: string;
  country: any;
  country_code: any;
  phone: string;
  password: string;
};

const defaultState: SessionInfo = {
  roomName: "",
  roomType: 2,
  role: "",
  yourName: "",
  name: "",
  email: "",
  country: 197,
  country_code: 966,
  phone: "",
  password: "",
};

function RegisterPage() {
  const classes = useStyles();
  const history = useHistory();
  const [session, setSessionInfo] = useState<SessionInfo>(defaultState);
  const [required, setRequired] = useState<any>({} as any);
  const [countryCode, setCountryCode] = useState(966);
  const [countries, getCountriesdata] = useState<any[]>([]);

  const [termsAndConditions, setTermsAndConditions] = React.useState(false);
  const [termsAndConditionsText, setTermsAndConditionsText] =
    React.useState(false);

  const [addCodeModalShow, setAddCodeModalShow] = React.useState(false);

  const [requiredModalShow, setRequiredModalShow] = React.useState(false);

  const [passwordLength, setPasswordLength] = React.useState(false);

  const [validEmail, setValidEmail] = React.useState(false);
  const [lang, setLang] = useState<string>("");

  const [countryValue, setCountryValue] = useState(197);
  const [countryLabel, setCountryLabel] = useState(
    JSON.parse(localStorage.getItem("language") as string) === "en" ||
      JSON.parse(localStorage.getItem("language") as string) === "en-US"
      ? "Saudi Arabia"
      : "المملكة العربية السعودية"
  );

  const is_sms_check = remoteConfig.getBoolean("is_check_sms");

  React.useEffect(() => {
    const lang = GlobalStorage.getLanguage().language;

    const fetchData = async () => {
      //const response = await axios.get(`${API_COMMON_URL}/countries`);
      const lang =
        JSON.parse(localStorage.getItem("language") as string) === "en-US" ||
        JSON.parse(localStorage.getItem("language") as string) === "en"
          ? "en"
          : "ar";
      const response = await axios(`${API_COMMON_URL}/countries`, {
        method: "GET",
        headers: {
          "x-localization": lang,
        },
      });
      getCountriesdata(response.data.data);
    };
    fetchData();
    setLang(lang);
  }, []);

  const findCountryCode = (countryId: any) => {
    let data = _.filter(countries, { id: countryId });
    setCountryCode(data[0].country_code);
    session.country_code = data[0].country_code;
    localStorage.setItem(
      "countryCode",
      `${JSON.stringify(data[0].country_code)}`
    );
  };

  const handleTermsAndConditions = (e: any) => {
    if (e.target.value) {
      setTermsAndConditions(true);
    } else {
      setTermsAndConditions(false);
    }
  };

  const changelang = (lang: string) => {
    if (lang == "ar") {
      localStorage.setItem("language", `${JSON.stringify("ar")}`);
      document.documentElement.lang = "ar";
      globalStore.setLanguage("ar");
    } else {
      localStorage.setItem("language", `${JSON.stringify("en")}`);
      document.documentElement.lang = "en";
      globalStore.setLanguage("en");
    }
  };

  const handleSubmit = () => {
    let validEmail =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    const roomLinkCode = JSON.parse(
      localStorage.getItem("roomLinkCode") as string
    );

    if (!termsAndConditions) {
      setTermsAndConditionsText(true);
    }
    if (
      !session.name ||
      !session.email ||
      !session.phone ||
      !session.password
    ) {
      setRequired({ ...required, missingField: t("allFieldsRequired") });
      return;
    }
    if (validEmail.test(session.email)) {
      setValidEmail(false);
    } else {
      setValidEmail(true);
    }

    if (session.password.length < 6) {
      setPasswordLength(true);
      return;
    } else {
      setPasswordLength(false);
    }

    if (termsAndConditions && validEmail.test(session.email)) {
      const regData = {
        name: session.name,
        email: session.email,
        country_id: session.country,
        phone: session.phone,
        password: session.password,
        password_confirmation: session.password,
        user_type_id: 1,
      };
      globalStore.showLoading();
      const lang =
        JSON.parse(localStorage.getItem("language") as string) === "en-US" ||
        JSON.parse(localStorage.getItem("language") as string) === "en"
          ? "en"
          : "ar";
      axios({
        method: "POST",
        headers: {
          "x-localization": lang,
        },
        url: `${API_V1_USERS}`,
        data: regData,
      })
        .then(
          (response) => {
            localStorage.setItem(
              "UserFullData",
              `${JSON.stringify(response.data.data)}`
            );
            //window.sessionStorage.setItem("UserFullData", `${JSON.stringify(response.data.data)}`);
            const formData = {
              grant_type: "password",
              client_id: 6,
              username: session.email,
              password: session.password,
              client_secret: "E8zatcU2OQmbB0JJDZCJBX9o9rHrrndIHLQShWOx",
            };
            axios({
              method: "POST",
              url: `${AUTH_API}`,
              data: formData,
            }).then((res: any) => {
              localStorage.setItem("UserData", `${JSON.stringify(res.data)}`);
              localStorage.setItem(
                "accessToken",
                `${JSON.stringify(res.data.access_token)}`
              );
            });
            history.push(roomLinkCode ? `/room/${roomLinkCode}` : `/`);
          },
          (error) => {
            globalStore.showToast({
              type: "rtmClient",
              message: t("toast.email_exists", { reason: error.message }),
            });
          }
        )
        .finally(() => {
          globalStore.stopLoading();
        });
    }
  };

  const [authorized, redirect] = useAuth("REGISTER");

  if (!authorized) {
    redirect();
    return null;
  }

  return (
    <div className="bg">
      <div className={`setting-container`}>
        {lang == "ar" ? (
          <button className="lang-btn" onClick={() => changelang("en")}>
            <span>English</span>
            <Language />
          </button>
        ) : (
          <button className="lang-btn" onClick={() => changelang("ar")}>
            <span>عربي</span> <Language />
          </button>
        )}
      </div>
      <div
        className={`flex-container register ${JSON.parse(
          localStorage.getItem("language") as string
        )}`}
      >
        <div className="register">
          <div className="header">
            <div className="logo"></div>
          </div>
          <div
            style={{
              flexDirection: "row",
              display: "flex",
              justifyContent: "start",
              alignItems: "baseline",
              width: "112%",
            }}
          >
            <Button
              className="register-back-icon"
              onClick={() => {
                history.push("/login");
              }}
              name={lang == "ar" ? <ArrowForward /> : <ArrowBack />}
            ></Button>
            <h2 className="register-title">{t("register_new_account")}</h2>
          </div>
          {required.missingField && required.missingField}
          <div className="position-content flex-direction-column">
            <FormControl className={classes.formControl}>
              <FormInput
                placeholder={t("fullName")}
                icon={<Person />}
                value={session.name}
                onChange={(val: string) => {
                  setSessionInfo({
                    ...session,
                    name: val,
                  });
                }}
                required
              />
            </FormControl>
            <FormControl className={classes.formControl}>
              <FormInput
                placeholder={t("email")}
                value={session.email}
                icon={<Email />}
                type="email"
                onChange={(val: string) => {
                  setSessionInfo({
                    ...session,
                    email: val,
                  });
                }}
              />
              {validEmail ? <p>{t("enterCorrectEmailFormat")} </p> : ""}
            </FormControl>
            <FormControl className={classes.formControl}>
              <Select
                onChange={(evt: any) => {
                  session.country = evt.value;
                  setCountryValue(evt.value);
                  setCountryLabel(evt.label);
                  findCountryCode(evt.value);
                }}
                options={countries.map((it: any) => ({
                  value: it.id,
                  label: it.name,
                }))}
                value={{ value: countryValue, label: `${countryLabel}` }}
              />
            </FormControl>
            <div className="flex-row-mobile">
              <FormControl className={classes.formControl + " country-field"}>
                <FormInput
                  className="country-code"
                  Label={"Country Code"}
                  value={countryCode > 0 ? countryCode : ""}
                  disabled
                  onChange={(val: number) => {
                    setSessionInfo({
                      ...session,
                      country_code: countryCode,
                    });
                  }}
                />
              </FormControl>
              <FormControl className={classes.formControl + " mobile-field"}>
                <FormInput
                  className="mobile-number"
                  placeholder={t("mobile")}
                  value={session.phone}
                  icon={<PhoneAndroid />}
                  onChange={(val: string) => {
                    setSessionInfo({
                      ...session,
                      phone: val,
                    });
                  }}
                  type="number"
                />
              </FormControl>
            </div>
            <FormControl className={classes.formControl}>
              <FormInput
                className="password"
                placeholder={t("password")}
                value={session.password}
                icon={<Https />}
                onChange={(val: string) => {
                  setSessionInfo({
                    ...session,
                    password: val,
                  });
                }}
                type="password"
              />
              {passwordLength ? (
                <p className="password-length">{t("passwordLength")}</p>
              ) : (
                ""
              )}
            </FormControl>
            <div className="checkbox">
              <Checkbox
                name="termsandconditions"
                value={termsAndConditions}
                required
                color="default"
                inputProps={{ "aria-label": "checkbox with default color" }}
                onChange={(e) => {
                  handleTermsAndConditions({
                    target: {
                      name: e.target.name,
                      value: e.target.checked,
                    },
                  });
                }}
              />
              <div className="text">
                {t("confirm_terms_conditions")}
                <Button
                  name={t("terms_conditions")}
                  className="terms-and-conditions-butt"
                  onClick={() => {
                    setAddCodeModalShow(true);
                  }}
                />
              </div>
            </div>
            {termsAndConditionsText ? (
              <p className="terms-and-conditions">{t("requiredField")}</p>
            ) : (
              ""
            )}
            <Button name={t("join2")} onClick={handleSubmit} />
          </div>
        </div>
        <Modal
          show={requiredModalShow}
          dialogClassName={"sign-in"}
          backdropClassName={"sign-in-modal"}
          onHide={() => {
            setRequiredModalShow(false);
          }}
          backdrop
          size={"md"}
        >
          <Modal.Header />
          <Modal.Body>
            <div>All felids are required!</div>
          </Modal.Body>
        </Modal>
        <Modal
          show={addCodeModalShow}
          dialogClassName={"terms-dialog"}
          backdropClassName={"sign-in-modal"}
          onHide={() => {
            setAddCodeModalShow(false);
          }}
          backdrop
          size={"md"}
        >
          <Modal.Header />
          <Modal.Body>
            <div>
              <h5>iHrMeet Privacy Policy</h5>
              <p>Updated: January 7th, 2019</p>
              <p>
                Welcome, and thank you for your interest in iHrMeet, Inc. (“
                iHrMeet,” “we,” or “us”) and our website at www.ihrmeet.com (the
                “Site”), as well as all related web sites, networks, embeddable
                widgets, downloadable software (including any development kits
                and any associated tools also known as SDKs), mobile
                applications, and other services provided by us and on or
                through which a link to this Privacy Policy (this “Policy”) is
                displayed (collectively, together with the Site, our “Service”).
              </p>
              <p>
                This Policy describes how iHrMeet may collect, use, process,
                disclose, and safeguard information we obtain through the
                Service and in connection with our customer, partner and vendor
                relationships. It also tells you about your rights and choices
                with respect to your information, and how you can contact us if
                you have any questions or concerns.
              </p>
              <p>
                In addition to the activities described in this Policy, we may
                process Personal Information provided by our enterprise
                customers (“Enterprise Customers”) when they use our Service. We
                process such Personal Information as a data processor on behalf
                and on the instructions of our Enterprise Customers, which are
                the entities responsible for the data processing. To understand
                how an Enterprise Customer processes your Personal Information,
                please refer to that Enterprise Customer’s privacy policy.
              </p>
              <p>
                This Policy is incorporated into and is subject to the iHrMeet
                Terms of Service. Capitalized terms used but not defined in this
                Policy have the meaning given to them in the iHrMeet Terms of
                Service.
              </p>
              <h5>1. Personal Information We Collect</h5>
              <p>
                For the purpose of this Policy, “Personal Information” means any
                information relating to an identified or identifiable
                individual. We obtain Personal Information relating to you from
                various sources described below.
              </p>
              <p>
                Where applicable, we indicate whether and why you must provide
                us with your Personal Information, as well as the consequences
                of failing to do so. If you do not provide Personal Information
                when requested, you may not be able to benefit from our Service
                if that information is necessary to provide you with the service
                or if we are legally required to collect it.
              </p>
              <h5>a. Personal Information Provided by You</h5>
              <p>
                Account Registration. If you register to use the Service, then
                you must provide us with your name, email address, and a
                password in order to create an account and user profile. You may
                also optionally add other information, such as a photo of
                yourself.
              </p>
              <p>
                User Content. We will collect any information you upload, post,
                or stream through the Service. For example, when you interact
                with other users by sending them messages or video chats, the
                Service will process the information you provide in such
                submissions, to the extent permitted under applicable law. This
                may also include the information regarding your contacts that
                you choose to import into the Service.
              </p>
              <p>
                Communications. We will collect any information which you
                provide to us through your communications e.g., when you
                communicate with our customer support team.
              </p>
              <h5>b. Personal Information Collected via Automated Means</h5>
              <p>
                In addition to information that you provide to us, we may
                collect information about you and your use of the Service via
                automated means, such as cookies, web beacons and similar
                technologies:
              </p>
              <p>
                Cookies and Similar Technologies. When you use the Service, we
                may send one or more cookies – small text files containing a
                string of alphanumeric characters – to your device. We may use
                both session cookies and persistent cookies to automatically
                collect certain information. A session cookie disappears after
                you close your browser. A persistent cookie remains after you
                close your browser and may be used by your browser on subsequent
                visits to the Service. When you use the Service, we may also
                automatically collect certain information from your device by
                using similar technologies, including “clear gifs” or “web
                beacons.” Please review your web browser “Help” file to learn
                the proper way to modify your settings with regard to such
                automated data collection. Please note that if you delete, or
                choose not to accept, such technologies from the Service, you
                may not be able to utilize the features of the Service to their
                fullest potential.
              </p>
              <p>
                The automatically collected information may include your IP
                address or other device address or ID, web browser and/or device
                type, the web pages or sites that you visit just before or just
                after you use the Service, the pages or other content you view
                or otherwise interact with on the Service, and the dates and
                times that you visit, access, or use the Service. We also may
                use these technologies to collect information regarding your
                interaction with email messages, such as whether you opened,
                clicked on, or forwarded a message. This information is gathered
                from all users.
              </p>
              <p>
                We use this information to assess how many users access or use
                our Service, which content, products, and features of our
                Service most interest our visitors, what types of offers our
                customers like to see, and how our service performs from a
                technical point of view.
              </p>
              <p>
                Google Analytics. We work with Google Analytics, which uses
                cookies and similar technologies to collect and analyze
                information about use of the website and report on activities
                and trends. You can learn about Google’s practices by going to
                https://www.google.com/policies/privacy/partners/, and opt out
                of them by downloading the Google Analytics opt-out browser
                add-on, available at https://tools.google.com/dlpage/gaoptout.
              </p>
              <p>
                Third Party Web Beacons and Third Party Buttons. We may also
                implement third-party content or advertising on the Service that
                may use clear gifs or other forms of web beacons, which allow
                the third-party content provider to read and write cookies to
                your browser in connection with your viewing of the third party
                content on the Service. Additionally, we may implement third
                party buttons (such as Facebook “like” or “share” buttons) that
                may allow third parties to collect information about you through
                such third parties’ browser cookies, even when you do not
                interact with the button. Information collected through web
                beacons and buttons is collected directly by these third
                parties, and iHrmeet does not participate in that data
                transmission. Information collected by a third party in this
                manner is subject to that third party’s own data collection,
                use, and disclosure policies.
              </p>
              <h5>c. Personal Information Obtained from Third Parties</h5>
              <p>
                Our Enterprise Customers. If you are using the Service as an end
                user of an Enterprise Customer, we may collect Personal
                Information about you from our Enterprise Customers who use the
                Services with their own end users, often their employees. This
                information may include [your name, email address, and phone
                number].
              </p>
              <h5>2. How We Use Personal Information We Collect</h5>
              <p>
                We may use Personal Information we collect for the following
                purposes:
              </p>
              <p>
                <b>Internal and Service-Related Usage.</b> We use your Personal
                Information to operate, maintain, enhance and provide all
                features of the Service, to provide services and information
                that you request, to respond to comments and questions and
                otherwise to provide support to users.
              </p>
              <p>
                <b>Analytics and Improving the Service.</b> We use your Personal
                Information to understand and analyze the usage trends and
                preferences of our users, to improve the Service, and to develop
                new products, services, feature, and functionality.
              </p>
              <p>
                <b>Communications.</b> We may use your email address or other
                Personal Information (i) to contact you for administrative
                purposes such as customer service, to address intellectual
                property infringement, privacy violations or defamation issues
                related to your User Content posted on the Service or (ii) to
                send communications, including updates on promotions, relating
                to products and services offered by us and by third parties we
                work with. Generally, you have the ability to opt-out of
                receiving any promotional communications as described below
                under “Your Rights and Choices.”
              </p>
              <p>
                <b>Tailored Content.</b> We may use your Personal Information
                to: (i) personalize our services, such as remembering your
                information so that you will not have to re-enter it during your
                visit or the next time you visit the Service; (ii) provide
                customized advertisements, content, and information.
              </p>
              <p>
                <b>Advertising.</b> We and our advertising partners may use your
                Personal Information, including your activities on the Service,
                to facilitate the delivery of advertisements.
              </p>
              <p>
                <b>Aggregate Data.</b> We may de-identify and aggregate
                information to monitor and analyze the effectiveness of Service
                and third-party marketing activities and to monitor aggregate
                site usage metrics such as total number of visitors and pages
                viewed.
              </p>
              <p>
                <b>Partners and Vendors.</b> We use Personal Information
                collected from our business partners and vendors to manage those
                relationships.
              </p>
              <p>
                <b>Legal.</b> We may use your Personal Information to enforce
                our End User License Agreement and Terms of Service, to defend
                our legal rights, to comply with our legal obligations and
                internal policies.
              </p>
              <p>
                <b>Other Purposes.</b> We also may use your Personal Information
                as may be described in a notice to you at the time the
                information is collected, or in any other manner to which you
                consent.
              </p>
              <p>
                If you are located in the European Economic Area, we only
                process your Personal Information based on a valid legal ground,
                including when:
              </p>
              <p>
                - You have consented to the use of your Personal Information;
              </p>
              <p>
                - We need your Personal Information to provide you with the
                Services, including for account registration and to respond to
                your inquiries;
              </p>
              <p>
                - We have a legal obligation to use your Personal Information;
              </p>
              <p>
                - We or a third party, have a legitimate interest in using your
                Personal Information. In particular, we have a legitimate
                interest in using your Personal Information to conduct business
                analytics, and otherwise improve the safety, security, and
                performance of our Services. We only rely on our or a third
                party’s legitimate interests to process your Personal
                Information when these interests are not overridden by your
                rights and interests.
              </p>
              <h5>3. How We Disclose Your Personal Information</h5>
              <p>
                Except as described in this Policy or otherwise disclosed to you
                at the time of the collection, we will not disclose your
                Personal Information to third parties without your consent. We
                may disclose information to third parties in the following
                circumstances:
              </p>
              <p>
                <b>- Other users.</b> Any Personal Information that you
                voluntarily choose to include on or through the Service,
                including information in a publicly accessible area of the
                Service (such as a public profile page) or information you share
                with or allow to be shared with other users, will be available
                to anyone who has access to that content, including other users.
                We are not responsible for privacy practices of the other Users
                who will view and use the posted information.{" "}
              </p>
              <p>
                <b>- Vendors and Service Providers.</b> We work with third party
                service providers to provide website or application development,
                hosting, maintenance, and other services for us. These third
                parties may have access to or process your Personal Information
                as part of providing those services for us. We limit the
                information provided to these service providers to that which is
                necessary for them to perform their functions, and we require
                them to agree to maintain the confidentiality of such
                information.
              </p>
              <p>
                <b>- Advertising Partners.</b> We may share your Personal
                Information with our third party advertising partners to provide
                ads that we think may interest you. For more information about
                our advertising and marketing practices and those of the third
                party advertising partners, please see the Personal Information
                Collected by Automated Means section above.
              </p>
              <p>
                <b>- Our Enterprise Customers.</b> If you are using the Service
                as an end user of an Enterprise Customer, we may disclose
                information about you with that Enterprise Customer, such as
                [list data categories that is accessible by or provided to the
                customer].
              </p>
              <p>
                <b>- Other Third Parties.</b> We may also share Personal
                Information about you with other third parties in the following
                circumstances:
              </p>
              <p>
                <b>- In Aggregated Form.</b> We may make certain
                automatically-collected, aggregated, or otherwise de-identified
                information available to third parties for various purposes,
                including (i) compliance with various reporting obligations;
                (ii) for business or marketing purposes; or (iii) to assist such
                parties in understanding our users’ interests, habits, and usage
                patterns for certain programs, content, services,
                advertisements, promotions, and/or functionality available
                through the Service.
              </p>
              <p>
                <b>- To Comply with Legal Obligations.</b> We may disclose your
                information if required to do so by law or in the good-faith
                belief that such action is necessary to comply with state and
                federal laws (such as U.S. copyright law), in response to a
                court order, judicial or other government subpoena or warrant,
                or to otherwise cooperate with law enforcement or other
                governmental agencies.
              </p>
              <p>
                <b>- To Protect and Enforce Our Rights.</b> We also reserve the
                right to disclose your information that we believe, in good
                faith, is appropriate or necessary to (i) take precautions
                against liability, (ii) protect ourselves or others from
                fraudulent, abusive, or unlawful uses or activity, (iii)
                investigate and defend ourselves against any third-party claims
                or allegations, (iv) protect the security or integrity of the
                Service and any facilities or equipment used to make the Service
                available, or (v) protect our property or other legal rights
                (including, but not limited to, enforcement of our agreements),
                or the rights, property, or safety of others.
              </p>
              <p>
                <b>- In case of Merger, Sale, or Other Asset Transfer.</b>{" "}
                Information about our users, including Personal Information, may
                be disclosed and otherwise transferred to an acquirer, or
                successor or assignee as part of any merger, acquisition, debt
                financing, sale of assets, or similar transaction, as well as in
                the event of an insolvency, bankruptcy, or receivership in which
                information is transferred to one or more third parties as one
                of our business assets.
              </p>
              <p>
                <b>- With Your Consent.</b> We also may disclose your Personal
                Information as may be described in a notice to you at the time
                the information is collected, or in any other manner to which
                you consent.
              </p>
              <h5>Your Rights and Choices</h5>
              <p>
                <b>Account Information. </b> You may, of course, decline to
                share certain Personal Information with us, in which case we may
                not be able to provide to you some of the features and
                functionality of the Service. You may update, correct, or delete
                your profile information and preferences at any time by
                accessing your account settings page on the Service. If you wish
                to access or amend any other Personal Information we hold about
                you, or to request that we delete any information about you that
                we have obtained from an Enterprise Customer, you may contact us
                at info@ihrmeet.com. Please note that while any changes you make
                will be reflected in active user databases instantly or within a
                reasonable period of time, we may retain all information you
                submit for backups, archiving, prevention of fraud and abuse,
                analytics, satisfaction of legal obligations, or where we
                otherwise reasonably believe that we have a legitimate reason to
                do so, to the extent permitted under applicable law.
              </p>
              <p>
                <b>Opt-Out.</b> If you receive commercial email from us, you may
                unsubscribe at any time by following the instructions contained
                within the email. You may also opt-out from receiving commercial
                email from us, and any other promotional communications that we
                may send to you from time to time, by sending your request to us
                by email info@ihrmeet.com or by writing to us at the address
                given at the end of this policy. We may allow you to view and
                modify settings relating to the nature and frequency of
                promotional communications that you receive from us in user
                account functionality on the Service.
              </p>
              <p>
                Please be aware that if you opt-out of receiving commercial
                email from us or otherwise modify the nature or frequency of
                promotional communications you receive from us, it may take up
                to ten business days for us to process your request, and you may
                receive promotional communications from us that you have
                opted-out from during that period, unless we are required by
                applicable law to process your request within a shorter period
                of time. Additionally, even after you opt-out from receiving
                commercial messages from us, you will continue to receive
                administrative messages from us regarding the Service.
              </p>
              <p>
                <b>Privacy Settings.</b> Although we may allow you to adjust
                your privacy settings to limit access to certain Personal
                Information, please be aware that no security measures are
                perfect or impenetrable. To the fullest extent permitted under
                applicable law, we are not responsible for circumvention of any
                privacy settings or security measures on the Service.
                Additionally, we cannot control the actions of other users with
                whom you may choose to share your information. Further, even
                after information posted on the Service is removed, caching and
                archiving services may have saved that information, and other
                users or third parties may have copied or stored the information
                available on the Service. To the fullest extent permitted under
                applicable law, we cannot and do not guarantee that information
                you post on or transmit to the Service will not be viewed by
                unauthorized persons.
              </p>
              <p>
                <b>Do Not Track.</b> Some web browsers incorporate a “Do Not
                Track” feature. Because there is not yet an accepted standard
                for how to respond to Do Not Track signals, our website does not
                currently respond to such signals.
              </p>
              <p>
                <b>Other Rights.</b> If you are located in the European Economic
                Area, you may have the following additional rights:
              </p>
              <p>
                - Request access to and receive information about the Personal
                Information we maintain about you, to update and correct
                inaccuracies in your Personal Information, to restrict or to
                object to the processing of your Personal Information, to have
                the information anonymized or deleted, as appropriate, or to
                exercise your right to data portability to easily transfer your
                Personal Information to another company. In addition, you may
                also have the right to lodge a complaint with a supervisory
                authority, including in your country of residence, place of work
                or where an incident took place.
              </p>
              <p>
                - Withdraw any consent you previously provided to us regarding
                the processing of your Personal Information, at any time and
                free of charge. We will apply your preferences going forward and
                this will not affect the lawfulness of the processing before
                your consent withdrawal.
              </p>
              <p>
                Those rights may be limited in some circumstances by local law
                requirements. You may exercise these rights by using the How to
                Contact Us below.
              </p>
              <h5>5. Third-Party Services</h5>
              <p>
                This Privacy Policy applies only to the processing of your
                Personal Information by iHrMeet. The Service may contain
                features or links to Web sites and services provided by third
                parties. The policies and procedures described in this Privacy
                Policy do not apply to Third Party Sites. Any information you
                provide on third-party sites or services is provided directly to
                the operators of such services and is subject to those
                operators’ policies, if any, governing privacy and security,
                even if accessed through the Service. We are not responsible for
                the content or privacy and security practices and policies of
                third-party sites or services to which links or access are
                provided through the Service. We encourage you to learn about
                third parties’ privacy and security policies before providing
                them with information.
              </p>
              <h5>6. Children’s Privacy</h5>
              <p>
                Protecting the privacy of young children is especially
                important. Our Service is not directed to children under the age
                of 16, and we do not knowingly collect Personal Information from
                children under the age of 16 without obtaining parental consent.
                If you are under 16 years of age, then please do not use or
                access the Service at any time or in any manner. If we learn
                that Personal Information has been collected on the Service from
                persons under 16 years of age and without verifiable parental
                consent, then we will take the appropriate steps to delete this
                information. If you are a parent or guardian and discover that
                your child under 16 years of age has obtained an account on the
                Service, then you may alert us at info@ihrmeet.com. and request
                that we delete that child’s Personal Information from our
                systems.
              </p>
              <h5>7. Data Security</h5>
              <p>
                We use certain physical, managerial, and technical safeguards
                that are designed to appropriately protect Personal Information
                against accidental or unlawful destruction, accidental loss,
                unauthorized alteration, unauthorized disclosure or access,
                misuse, and any other unlawful form of processing of the
                Personal Information in our possession. WE CANNOT, HOWEVER,
                ENSURE OR WARRANT THE SECURITY OF ANY INFORMATION YOU TRANSMIT
                TO US OR STORE ON THE SERVICE, AND YOU DO SO AT YOUR OWN RISK.
                WE ALSO CANNOT GUARANTEE THAT SUCH INFORMATION MAY NOT BE
                ACCESSED, DISCLOSED, ALTERED, OR DESTROYED BY BREACH OF ANY OF
                OUR PHYSICAL, TECHNICAL, OR MANAGERIAL SAFEGUARDS. The foregoing
                is subject to requirements under applicable law to ensure or
                warrant information security.
              </p>
              <p>
                If we learn of a security systems breach, then we may attempt to
                notify you electronically so that you can take appropriate
                protective steps. We may post a notice through the Service if a
                security breach occurs. Depending on where you live, you may
                have a legal right to receive notice of a security breach in
                writing. To receive a free written notice of a security breach
                you should notify us at info@ihrmeet.com.
              </p>
              <h5>8. Data Retention</h5>
              <p>
                We take measures to delete your Personal Information or keep it
                in a form that does not permit identifying you when this
                information is no longer necessary for the purposes for which we
                process it, unless we are required by law to keep this
                information for a longer period. When determining the retention
                period, we take into account various criteria, such as the type
                of products and services requested by or provided to you, the
                nature and length of our relationship with you, possible
                re-enrolment with our products or services, the impact on the
                services we provide to you if we delete some information from or
                about you, mandatory retention periods provided by law and the
                statute of limitations.
              </p>
              <h5>9. Data Transfers</h5>
              <p>
                The Service is hosted in the United States and is intended for
                visitors located within the United States. If you choose to use
                the Service from the European Union or other regions of the
                world with laws governing data collection and use that may
                differ from U.S. law, then please note that you are transferring
                your Personal Information outside of those regions to the United
                States for storage and processing. Also, we may transfer your
                data from the U.S. to other countries or regions in connection
                with storage and processing of data, fulfilling your requests,
                and operating the Service. By providing any information,
                including Personal Information, on or to the Service, you
                consent to such transfer, storage, and processing pursuant to
                either the Terms of Service or an Enterprise Customer agreement,
                as applicable.
              </p>
              <p>
                When we transfer Personal Information outside of the European
                Economic Area, we will comply with applicable EU data protection
                laws. We may transfer your Personal Information to countries
                which provide an adequate level of protection under EU law, we
                may use contractual protections for the transfer of Personal
                Information, or rely on a certification to the Privacy Shield
                framework. You may contact us as specified below to obtain a
                copy of the safeguards we use to transfer Personal Information
                outside of the European Economic Area.
              </p>
              <h5>10. Changes and Updates to this Policy</h5>
              <p>
                Please revisit this page periodically to stay aware of any
                changes to this Policy, which we may update from time to time.
                If we modify the Policy, we will make it available through the
                Service, and indicate the date of the latest revision. In the
                event that the modifications materially alter your rights or
                obligations hereunder, we will make reasonable efforts to notify
                you of the change. For example, we may send a message to your
                email address, if we have one on file, or generate a pop-up or
                similar notification when you access the Service for the first
                time after such material changes are made. Your continued use of
                the Service after the revised Policy has become effective
                indicates that you have read, understood and agreed to the
                current version of the Policy.
              </p>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
}
export default React.memo(RegisterPage);
